"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sign_sold = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var sign_sold = function sign_sold(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'sign-sold-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M4.39453 13.0742C4.39844 13.6328 4.85742 13.9746 5.60547 13.9746C6.375 13.9746 6.83594 13.6113 6.83594 13.002C6.83594 12.5449 6.58203 12.2852 6.0332 12.1895L5.64844 12.123C5.37891 12.0762 5.26367 11.998 5.26367 11.8633C5.26367 11.707 5.4043 11.6094 5.61914 11.6094C5.83984 11.6094 6.01367 11.7383 6.01953 11.9082H6.77734C6.77148 11.3672 6.29688 11 5.60156 11C4.89648 11 4.44141 11.3711 4.44141 11.9453C4.44141 12.4004 4.72266 12.6973 5.24023 12.7871L5.61328 12.8535C5.91602 12.9082 6.02148 12.9707 6.02148 13.1016C6.02148 13.2598 5.86719 13.3633 5.63477 13.3633C5.36914 13.3633 5.18945 13.25 5.17969 13.0742H4.39453Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M8.64453 11C7.7832 11 7.22461 11.5664 7.22461 12.4863C7.22461 13.4102 7.7793 13.9746 8.64453 13.9746C9.50586 13.9746 10.0625 13.4102 10.0625 12.4863C10.0625 11.5664 9.50586 11 8.64453 11ZM8.64453 11.6758C8.98438 11.6758 9.21875 11.9922 9.21875 12.4863C9.21875 12.9824 8.98438 13.2988 8.64453 13.2988C8.30273 13.2988 8.06836 12.9824 8.06836 12.4863C8.06836 11.9922 8.30273 11.6758 8.64453 11.6758Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M12.5488 13.2207H11.4004V11.0781H10.5723V13.8965H12.5488V13.2207Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M13.0605 11.0781V13.8965H14.3105C15.1621 13.8965 15.625 13.3887 15.625 12.4512C15.625 11.5703 15.1523 11.0781 14.3105 11.0781H13.0605ZM13.8887 11.7344H14.1484C14.5469 11.7344 14.7812 11.9922 14.7812 12.4668C14.7812 12.9863 14.5625 13.2402 14.1484 13.2402H13.8887V11.7344Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10.5303 1.21967C10.2374 0.926777 9.76256 0.926777 9.46967 1.21967L4.68934 6H2C1.58579 6 1.25 6.33579 1.25 6.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V6.75C18.75 6.33579 18.4142 6 18 6H15.3107L10.5303 1.21967ZM13.1893 6L10 2.81066L6.81066 6H13.1893ZM2.75 17V7.5H17.25V17H2.75Z',
    fill: '#4B5563'
  }));
};

exports.sign_sold = sign_sold;